import { GenericService } from '@/services/api/generic.service';
import { Form } from '@/models';

export class FormService extends GenericService<Form> {
  endpoint = 'v1/forms';
}
